<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <div class="relative flex items-center">
        <button
            class="absolute z-50 flex items-center justify-center w-4 h-4 border rounded-full md:w-6 md:h-6 border-primary -left-5 md:-left-8"
            (click)="goback()">
            <mat-icon
                class="w-[5px] h-[3px] mr-[1px] min-w-[5px] min-h-[3px] md:w-[7.5px] md:h-[4.5px] md:min-w-[7.5px] md:min-h-[4.5px] text-primary rotate-90"
                svgIcon="icons:arrow-icon">
            </mat-icon>
        </button>
        <h1 class="text-black title-6 md:title-3">Rango de folios: {{ folioMinimo }}-{{ folioMaximo }}</h1>
    </div>
    <div>
        <div class="flex gap-3 mt-3 mb-3 md:px-5 md:mt-10">
            <div>
                <p class="font-light title-11">Folios disponibles</p>
                <p class="title-6">{{ foliosDisponibles }}</p>
            </div>
            <div class="">
                <p class="font-light title-11">Folios anulados</p>
                <p class="title-6">{{ foliosAnulados }}</p>
            </div>
        </div>
    </div>

    <!-- TABLE DESKTOP -->
    <app-mat-custom-table
        [use_selection]="false"
        [use_detail]="false"
        [dataset]="dataSourceFolios"
        [columns]="columnsFolios">
    </app-mat-custom-table>
</main>
